import axios from '../axios';
import { OTP_TEAM_PHONE_VERIFY, REG_BRANCH_UPDATE_BRANCH_PHONE } from '../ApiUrl';

/**
 * POST `/OtpTeamPhoneVerify` — team SMS OTP generate / verify.
 * @param {{ team_user_id: string, phone_no: string, serviceType: string, otpNo?: string }} payload
 */
export const regBranchPhoneVerificationAPI = async (payload) => {
  try {
    const response = await axios.post(OTP_TEAM_PHONE_VERIFY, payload);
    return response;
  } catch (error) {
    console.log('regBranchPhoneVerificationAPI catch block', error);
    return { hasError: true, error };
  }
};

/**
 * PUT — update branch phone from OTP flow (mirrors kitchen `updateKitchenOperationAPI`).
 * @param {Record<string, unknown>} payload
 */
export const regBranchUpdateBranchPhoneAPI = async (payload) => {
  try {
    const response = await axios.put(REG_BRANCH_UPDATE_BRANCH_PHONE, payload);
    return response;
  } catch (error) {
    console.log('regBranchUpdateBranchPhoneAPI catch block', error);
    return { hasError: true, error };
  }
};
